module.exports = __webpack_public_path__ + "static/media/settings-white.7c39aa7c.svg";